/**
 * midas-cart.js — comportamento do carrinho drawer próprio da Midastime.
 *
 * O abrir/fechar, o contador e o re-render ficam com o Focal (cart-drawer#mini-cart
 * + eventos cart:refresh). Aqui só entram:
 *   - Finalizar compra pelo fluxo padrão da Yampi (via /cart)
 *   - Adicionar produto do upsell
 *   - Copiar cupom da barra de desconto
 *   - Neutralizar o HS Slide Cart enquanto os dois convivem
 *
 * Os listeners são delegados no document porque o Focal troca o innerHTML do drawer a cada atualização.
 */
(function () {
  'use strict';

  if (window.MidasCart) return;

  var YAMPI_CART_ENDPOINT = 'https://api.dooki.com.br/v2/public/shopify/cart';
  var CHECKOUT_TIMEOUT_MS = 10000;

  function drawer() {
    return document.getElementById('mini-cart');
  }

  function openDrawer() {
    var el = drawer();
    if (el) el.open = true;
  }

  function dispatchCart(cart, openMiniCart) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, openMiniCart: openMiniCart } }));
  }

  function setBusy(button, busy) {
    if (!button) return;
    button.disabled = busy;
    button.classList.toggle('is-busy', busy);
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  // ---------- Finalizar compra (Yampi) ----------

  function goToCartPage() {
    // A página /cart roda o YampiSnippet, que redireciona para o checkout da Yampi.
    window.location.href = '/cart';
  }

  function withUtms(url) {
    try {
      if (typeof window.ymp_getUrlWithUtms === 'function') return window.ymp_getUrlWithUtms(url);
    } catch (error) {
      console.error('Error in midas-cart withUtms:', error);
    }
    return url;
  }

  // Fluxo padrão da Yampi: o /cart envia o carrinho, esvazia o da Shopify, cola as UTMs e redireciona.
  function checkout(button) {
    setBusy(button, true);
    goToCartPage();
  }

  // ---------- Upsell: adição rápida (modal de cor + tamanho) ----------

  // Mesmas cores das amostras da PDP nova (bs-buy.js); kit de duas cores vira diagonal.
  var SWATCH = {
    'marrom': '#5b3326', 'preto': '#1c1c1c', 'off white': '#ece5d8', 'bege': '#d9b99b', 'nude': '#d9b99b', 'branco': '#ffffff'
  };

  function swatchFor(value) {
    var colors = String(value).toLowerCase().split('+').map(function (part) {
      return SWATCH[part.trim()] || null;
    });
    if (colors.indexOf(null) !== -1) return null;
    if (colors.length === 1) return colors[0];
    return 'linear-gradient(135deg, ' + colors[0] + ' 0 50%, ' + colors[1] + ' 50% 100%)';
  }

  function optionType(name) {
    if (/tamanho/i.test(name)) return 'size';
    if (/cor/i.test(name)) return 'color';
    return 'other';
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function addVariant(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: 'mini-cart' })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok) throw new Error(json.description || json.message || 'Falha ao adicionar');
          return json;
        });
      })
      .then(function (added) {
        return fetch('/cart.js', { credentials: 'same-origin' })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            cart.sections = added.sections;
            dispatchCart(cart, true);
          });
      });
  }

  var quickAdd = null;
  var quickAddState = null;

  function buildQuickAdd() {
    var modal = el('div', 'midas-qa');
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'midas-qa-title');
    modal.innerHTML =
      '<div class="midas-qa__backdrop" data-midas-qa-close></div>' +
      '<div class="midas-qa__box">' +
        '<header class="midas-qa__header">' +
          '<img class="midas-qa__image" alt="">' +
          '<div class="midas-qa__head-info">' +
            '<p class="midas-qa__title" id="midas-qa-title"></p>' +
            '<p class="midas-qa__price"></p>' +
          '</div>' +
          '<button type="button" class="midas-qa__close" data-midas-qa-close aria-label="Fechar">' +
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</header>' +
        '<div class="midas-qa__body"></div>' +
        '<p class="midas-qa__error" role="alert" hidden></p>' +
      '</div>';
    modal.addEventListener('click', onQuickAddClick);
    document.body.appendChild(modal);
    return modal;
  }

  function variantFor(selected) {
    return quickAddState.data.variants.find(function (variant) {
      return variant.o.every(function (value, index) { return selected[index] == null || selected[index] === value; });
    });
  }

  // Um valor fica ativo se existe variante disponível com ele e com as outras escolhas atuais (tamanho ignorado).
  function isAvailable(index, value) {
    var data = quickAddState.data;
    return data.variants.some(function (variant) {
      if (!variant.a || variant.o[index] !== value) return false;
      return variant.o.every(function (v, i) {
        return i === index || optionType(data.options[i]) === 'size' || quickAddState.selected[i] == null || quickAddState.selected[i] === v;
      });
    });
  }

  function uniqueValues(index) {
    var seen = [];
    quickAddState.data.variants.forEach(function (variant) {
      if (seen.indexOf(variant.o[index]) === -1) seen.push(variant.o[index]);
    });
    return seen;
  }

  function renderQuickAdd() {
    var data = quickAddState.data;
    var body = quickAdd.querySelector('.midas-qa__body');
    body.textContent = '';
    var hasSize = false;

    data.options.forEach(function (name, index) {
      var type = optionType(name);
      var group = el('div', 'midas-qa__group');
      var head = el('div', 'midas-qa__group-head');
      var label = el('p', 'midas-qa__label');
      label.appendChild(el('span', 'midas-qa__label-name', name + ':'));
      label.appendChild(document.createTextNode(' '));
      label.appendChild(el('span', 'midas-qa__label-value', type === 'size' ? 'escolha' : (quickAddState.selected[index] || '')));
      head.appendChild(label);

      if (type === 'size') {
        hasSize = true;
        if (data.sizeTable || data.sizeChart) {
          var guide = el('button', 'midas-qa__guide');
          guide.type = 'button';
          guide.setAttribute('data-midas-size-guide', data.sizeChart || '');
          if (data.sizeTable) guide.setAttribute('data-midas-size-table', JSON.stringify(data.sizeTable));
          guide.setAttribute('data-title', data.title);
          guide.innerHTML = '<svg width="18" height="10" viewBox="0 0 18 10" fill="none" aria-hidden="true"><rect x=".75" y=".75" width="16.5" height="8.5" rx="1.25" stroke="currentColor" stroke-width="1.5"/><path d="M4.5 1v3.5M7.5 1v2.5M10.5 1v3.5M13.5 1v2.5" stroke="currentColor" stroke-width="1.3"/></svg>';
          guide.appendChild(document.createTextNode('Qual é o meu tamanho?'));
          head.appendChild(guide);
        }
      }
      group.appendChild(head);

      var list = el('div', 'midas-qa__values midas-qa__values--' + type);
      uniqueValues(index).forEach(function (value) {
        var available = isAvailable(index, value);
        var button = el('button', 'midas-qa__value midas-qa__value--' + type);
        button.type = 'button';
        button.disabled = !available;
        button.setAttribute('data-index', index);
        button.setAttribute('data-value', value);

        if (type === 'color') {
          var swatch = swatchFor(value);
          button.setAttribute('aria-label', value);
          button.title = value;
          button.setAttribute('aria-pressed', quickAddState.selected[index] === value ? 'true' : 'false');
          if (swatch) {
            button.style.setProperty('--qa-swatch', swatch);
          } else {
            button.classList.add('midas-qa__value--text');
            button.textContent = value;
          }
        } else if (type === 'size') {
          button.appendChild(el('span', 'midas-qa__size', value));
          var range = data.manequim && data.manequim[value];
          if (range) button.appendChild(el('span', 'midas-qa__range', range));
          if (!available) button.setAttribute('aria-label', value + ' esgotado');
        } else {
          button.setAttribute('aria-pressed', quickAddState.selected[index] === value ? 'true' : 'false');
          button.textContent = value;
        }
        list.appendChild(button);
      });
      group.appendChild(list);
      body.appendChild(group);
    });

    // Sem opção de tamanho: um botão final adiciona a combinação escolhida.
    if (!hasSize) {
      var confirm = el('button', 'midas-qa__confirm', 'Adicionar no carrinho');
      confirm.type = 'button';
      confirm.setAttribute('data-midas-qa-confirm', '');
      body.appendChild(confirm);
    }
  }

  function openQuickAdd(trigger) {
    var card = trigger.closest('.midas-cart__upsell-card');
    var source = card && card.querySelector('[data-midas-quick-add-data]');
    if (!source) return;

    var data;
    try {
      data = JSON.parse(source.textContent);
    } catch (error) {
      console.error('Error in midas-cart openQuickAdd:', error);
      return;
    }

    // Produto sem opções: adiciona direto, sem modal.
    if (data.variants.length === 1) {
      setBusy(trigger, true);
      addVariant(data.variants[0].id).catch(function (error) {
        console.error('Error in midas-cart quick add:', error);
        setBusy(trigger, false);
      });
      return;
    }

    if (!quickAdd) quickAdd = buildQuickAdd();
    quickAddState = { data: data, selected: {}, trigger: trigger, busy: false };

    // Cor e demais opções já vêm escolhidas com a primeira combinação disponível; o tamanho fica em aberto.
    var firstAvailable = data.variants.find(function (variant) { return variant.a; }) || data.variants[0];
    data.options.forEach(function (name, index) {
      if (optionType(name) !== 'size') quickAddState.selected[index] = firstAvailable.o[index];
    });

    var image = quickAdd.querySelector('.midas-qa__image');
    image.src = data.image || '';
    image.hidden = !data.image;
    quickAdd.querySelector('.midas-qa__title').textContent = data.title;
    var price = quickAdd.querySelector('.midas-qa__price');
    price.textContent = '';
    if (data.compare) price.appendChild(el('s', 'midas-qa__compare', data.compare));
    price.appendChild(el('span', 'midas-qa__now', data.price));
    quickAdd.querySelector('.midas-qa__error').hidden = true;
    quickAdd.classList.remove('is-busy');

    renderQuickAdd();
    quickAdd.hidden = false;
    quickAdd.querySelector('.midas-qa__close').focus();
  }

  function closeQuickAdd() {
    if (!quickAdd || quickAdd.hidden) return;
    quickAdd.hidden = true;
    var trigger = quickAddState && quickAddState.trigger;
    if (trigger && document.body.contains(trigger)) trigger.focus();
  }

  function submitQuickAdd(selected, button) {
    var variant = variantFor(selected);
    var error = quickAdd.querySelector('.midas-qa__error');
    if (!variant || !variant.a) return;

    quickAddState.busy = true;
    quickAdd.classList.add('is-busy');
    if (button) button.classList.add('is-adding');
    error.hidden = true;

    addVariant(variant.id)
      .then(function () {
        quickAddState.busy = false;
        closeQuickAdd();
      })
      .catch(function (err) {
        console.error('Error in midas-cart submitQuickAdd:', err);
        quickAddState.busy = false;
        quickAdd.classList.remove('is-busy');
        if (button) button.classList.remove('is-adding');
        error.textContent = 'Não foi possível adicionar esse tamanho. Tente outro.';
        error.hidden = false;
      });
  }

  function onQuickAddClick(event) {
    if (quickAddState && quickAddState.busy) return;

    if (event.target.closest('[data-midas-qa-close]')) {
      closeQuickAdd();
      return;
    }

    var confirm = event.target.closest('[data-midas-qa-confirm]');
    if (confirm) {
      submitQuickAdd(quickAddState.selected, confirm);
      return;
    }

    var button = event.target.closest('.midas-qa__value');
    if (!button || button.disabled) return;
    var index = Number(button.getAttribute('data-index'));
    var value = button.getAttribute('data-value');

    if (optionType(quickAddState.data.options[index]) === 'size') {
      // Tocar no tamanho já adiciona e volta para o carrinho.
      var selected = {};
      Object.keys(quickAddState.selected).forEach(function (key) { selected[key] = quickAddState.selected[key]; });
      selected[index] = value;
      submitQuickAdd(selected, button);
      return;
    }

    quickAddState.selected[index] = value;
    renderQuickAdd();
  }

  // ---------- Remover item ----------

  // O X fica fora do line-item-quantity (que intercepta todo link dentro dele),
  // então reaproveita o método do Focal para manter loader e re-render iguais ao +/-.
  function removeItem(button) {
    var href = button.getAttribute('data-midas-remove');
    var item = button.closest('line-item');
    var quantity = item && item.querySelector('line-item-quantity');
    button.disabled = true;
    if (quantity && typeof quantity._updateFromLink === 'function') {
      quantity._updateFromLink(href);
    } else {
      window.location.href = href;
    }
  }

  // ---------- Combo montado ----------

  // Mais, menos e X mudam todas as linhas do combo juntas: o card tem as chaves das linhas
  // em data-kit-keys e a quantidade atual em data-kit-qty.
  function updateKit(button) {
    var kit = button.closest('[data-midas-kit]');
    if (!kit) return;
    var keys = (kit.getAttribute('data-kit-keys') || '').split(',').filter(Boolean);
    if (!keys.length) return;
    var current = parseInt(kit.getAttribute('data-kit-qty'), 10) || 1;
    var action = button.getAttribute('data-midas-kit-step');
    var next = action === 'remove' ? 0 : Math.max(0, Math.min(10, current + Number(action)));
    var updates = {};
    keys.forEach(function (key) { updates[key] = next; });
    kit.classList.add('is-busy');
    window.fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: 'mini-cart' })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok) throw new Error(json.description || json.message || 'Falha no carrinho');
          return json;
        });
      })
      .then(function (cart) {
        dispatchCart(cart, true);
        openDrawer();
      })
      .catch(function (error) {
        console.error('Erro ao mudar o combo:', error);
        kit.classList.remove('is-busy');
      });
  }

  // ---------- Tabela de medidas (modal) ----------

  // O modal fica no body (fora do drawer) para cobrir a página inteira e não ser recriado pelo re-render do Focal.
  var sizeModal = null;
  var sizeModalTrigger = null;

  function buildSizeModal() {
    var modal = document.createElement('div');
    modal.className = 'midas-size-modal';
    modal.hidden = true;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'midas-size-modal-title');
    modal.innerHTML =
      '<div class="midas-size-modal__backdrop" data-midas-size-close></div>' +
      '<div class="midas-size-modal__box">' +
        '<header class="midas-size-modal__header">' +
          '<p class="midas-size-modal__title" id="midas-size-modal-title">Tabela de medidas</p>' +
          '<button type="button" class="midas-size-modal__close" data-midas-size-close aria-label="Fechar tabela de medidas">' +
            '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M2 2l12 12M14 2L2 14" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</header>' +
        '<div class="midas-size-modal__body">' +
          '<p class="midas-size-modal__product"></p>' +
          '<img class="midas-size-modal__image" alt="">' +
          '<table class="midas-size-modal__table" hidden></table>' +
        '</div>' +
      '</div>';
    modal.addEventListener('click', function (event) {
      if (event.target.closest('[data-midas-size-close]')) closeSizeModal();
    });
    document.body.appendChild(modal);
    return modal;
  }

  // Tabela em dados (quando a imagem da descrição está desatualizada) ou a imagem oficial.
  function fillSizeTable(table, data) {
    table.textContent = '';
    var head = table.createTHead().insertRow();
    data.head.forEach(function (label) {
      var th = document.createElement('th');
      th.scope = 'col';
      th.textContent = label;
      head.appendChild(th);
    });
    var body = table.createTBody();
    data.rows.forEach(function (row) {
      var tr = body.insertRow();
      row.forEach(function (value, index) {
        var cell = document.createElement(index === 0 ? 'th' : 'td');
        if (index === 0) cell.scope = 'row';
        cell.textContent = value;
        tr.appendChild(cell);
      });
    });
  }

  // "Body Shaper - Body modelador canelado...": nome na 1ª linha, especificação (depois do primeiro " - ") na linha de baixo, sem o traço.
  function renderProductTitle(target, title) {
    var cut = title.indexOf(' - ');
    target.textContent = '';
    if (cut === -1) {
      target.appendChild(el('strong', 'midas-size-modal__product-name', title));
      return;
    }
    target.appendChild(el('strong', 'midas-size-modal__product-name', title.slice(0, cut).trim()));
    target.appendChild(el('span', 'midas-size-modal__product-spec', title.slice(cut + 3).trim()));
  }

  function openSizeModal(trigger) {
    if (!sizeModal) sizeModal = buildSizeModal();
    var title = trigger.getAttribute('data-title') || '';
    var image = sizeModal.querySelector('.midas-size-modal__image');
    var table = sizeModal.querySelector('.midas-size-modal__table');
    var tableData = null;
    try {
      tableData = JSON.parse(trigger.getAttribute('data-midas-size-table') || 'null');
    } catch (error) {
      console.error('Error in midas-cart openSizeModal:', error);
    }
    renderProductTitle(sizeModal.querySelector('.midas-size-modal__product'), title);
    if (tableData) {
      fillSizeTable(table, tableData);
      table.hidden = false;
      image.hidden = true;
      image.removeAttribute('src');
    } else {
      table.hidden = true;
      image.hidden = false;
      image.src = trigger.getAttribute('data-midas-size-guide');
      image.alt = 'Tabela de medidas de ' + title;
    }
    sizeModalTrigger = trigger;
    sizeModal.hidden = false;
    // Nome e especificação sempre numa linha cada
    fitToLine(sizeModal.querySelector('.midas-size-modal__product-name'), 12);
    fitToLine(sizeModal.querySelector('.midas-size-modal__product-spec'), 10);
    sizeModal.querySelector('.midas-size-modal__close').focus();
  }

  function closeSizeModal() {
    if (!sizeModal || sizeModal.hidden) return;
    sizeModal.hidden = true;
    if (sizeModalTrigger && document.body.contains(sizeModalTrigger)) sizeModalTrigger.focus();
    sizeModalTrigger = null;
  }

  // Esc fecha só o modal (captura antes do Focal, que fecharia o drawer junto).
  // Esc fecha a camada de cima (tabela, depois adição rápida) sem fechar o carrinho junto.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    if (sizeModal && !sizeModal.hidden) {
      event.stopImmediatePropagation();
      closeSizeModal();
    } else if (quickAdd && !quickAdd.hidden) {
      event.stopImmediatePropagation();
      closeQuickAdd();
    }
  }, true);

  // ---------- Cupom ----------

  function copyCoupon(button) {
    var code = button.getAttribute('data-midas-copy');
    var label = button.querySelector('[data-midas-copy-label]');
    if (!code || !navigator.clipboard) return;

    navigator.clipboard.writeText(code).then(function () {
      if (!label) return;
      label.textContent = 'Copiado!';
      button.classList.add('is-copied');
      setTimeout(function () {
        label.textContent = code;
        button.classList.remove('is-copied');
      }, 1600);
    }).catch(function (error) {
      console.error('Error in midas-cart copyCoupon:', error);
    });
  }

  // ---------- Barra de desconto numa linha só ----------

  var MIN_REWARDS_FONT = 11;

  // Reduz a fonte de meio em meio pixel até o texto caber numa linha (o elemento precisa de white-space: nowrap).
  function fitToLine(el, minSize) {
    if (!el || !el.clientWidth) return;
    el.style.fontSize = '';
    var size = parseFloat(window.getComputedStyle(el).fontSize);
    while (el.scrollWidth > el.clientWidth && size > minSize) {
      size -= 0.5;
      el.style.fontSize = size + 'px';
    }
  }

  function fitRewardsText() {
    fitToLine(document.querySelector('#mini-cart .midas-cart__rewards-text'), MIN_REWARDS_FONT);
  }

  // O Focal troca o conteúdo do drawer a cada atualização e anima a abertura: reajusta nos dois casos.
  function watchDrawer() {
    var el = drawer();
    if (!el || el.__midasObserved) return;
    el.__midasObserved = true;
    new MutationObserver(function () { window.requestAnimationFrame(fitRewardsText); })
      .observe(el, { childList: true, attributes: true, attributeFilter: ['open'] });
  }

  window.addEventListener('resize', fitRewardsText);

  // ---------- Convivência com o HS Slide Cart ----------

  function neutralizeHs() {
    document.documentElement.classList.add('midas-cart-on');

    Array.prototype.forEach.call(document.querySelectorAll('.hs-event-static'), function (el) {
      el.classList.remove('hs-event-static');
    });

    window.HS_SLIDE_CART_OPEN = openDrawer;
    window.HS_SLIDE_CART_CLOSE = function () {};
  }

  // ---------- Listeners ----------

  // Captura antes do HS: qualquer link/botão de carrinho fora do drawer abre o nosso.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[aria-controls="mini-cart"], a[href="/cart"]');
    if (!trigger || trigger.closest('#mini-cart')) return;
    if (window.themeVariables && window.themeVariables.settings.pageType === 'cart') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    closeQuickBuy();
    openDrawer();
  }, true);

  // "Escolher opções" (quick-buy do Focal) é um drawer, e o Focal não abre o carrinho
  // quando a adição vem de dentro de outro drawer: só mostra a barra verde. Aqui fechamos
  // o quick-buy e abrimos o carrinho logo depois do re-render.
  function closeQuickBuy() {
    document.querySelectorAll('quick-buy-drawer[open]').forEach(function (el) { el.open = false; });
  }

  var openAfterQuickBuy = false;

  document.addEventListener('variant:added', function (event) {
    if (event.target.closest && event.target.closest('quick-buy-drawer')) openAfterQuickBuy = true;
  });

  document.documentElement.addEventListener('cart:refresh', function () {
    if (!openAfterQuickBuy) return;
    openAfterQuickBuy = false;
    closeQuickBuy();
    setTimeout(openDrawer, 50);
  });

  document.addEventListener('click', function (event) {
    var target = event.target;

    var checkoutButton = target.closest('[data-midas-checkout]');
    if (checkoutButton) {
      event.preventDefault();
      checkout(checkoutButton);
      return;
    }

    var quickAddButton = target.closest('[data-midas-quick-add]');
    if (quickAddButton) {
      event.preventDefault();
      openQuickAdd(quickAddButton);
      return;
    }

    var kitStep = target.closest('[data-midas-kit-step]');
    if (kitStep) {
      event.preventDefault();
      updateKit(kitStep);
      return;
    }

    var removeButton = target.closest('[data-midas-remove]');
    if (removeButton) {
      event.preventDefault();
      removeItem(removeButton);
      return;
    }

    var sizeGuideButton = target.closest('[data-midas-size-guide]');
    if (sizeGuideButton) {
      event.preventDefault();
      openSizeModal(sizeGuideButton);
      return;
    }

    var copyButton = target.closest('[data-midas-copy]');
    if (copyButton) {
      event.preventDefault();
      copyCoupon(copyButton);
    }
  });

  // Volta do checkout pelo botão "voltar" do navegador: destrava o botão.
  window.addEventListener('pageshow', function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-midas-checkout]'), function (button) {
      setBusy(button, false);
    });
  });

  neutralizeHs();
  watchDrawer();
  window.addEventListener('load', function () {
    neutralizeHs();
    watchDrawer();
    fitRewardsText();
  });

  window.MidasCart = { open: openDrawer, checkout: checkout };
})();
